import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navbar sticky-top navbar-light white button-row strava pb-0" }
const _hoisted_2 = { class: "container-xl" }
const _hoisted_3 = { class: "row w-100 justify-content-between g-0 pb-5" }
const _hoisted_4 = { class: "col-md-12s btn-group pe-2 py-1 remove-p-r" }
const _hoisted_5 = { class: "row w-100 border-bottom border-dark g-0 mobile-font" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 text-center fw-bold" }, "#", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 fw-bold" }, "Navn", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 text-center fw-bold" }, "Poeng", -1)
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "container-xl w-100 strava pb-5 mobile-font" }
const _hoisted_11 = { class: "col-1 text-center" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "col-2 text-center fw-bold" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "row g-0" }
const _hoisted_17 = { class: "col-md fw-bold" }
const _hoisted_18 = { class: "col-md-5" }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
                            _ctx.changeType('Sprint'),
                                (_ctx.active.Sprint = true),
                                // (active.Tempo = false),
                                (_ctx.active.Hill = false),
                                (_ctx.active.Mountain = false)
                        )),
              class: _normalizeClass(["btn shadow-none custom-btn", { active: _ctx.active.Sprint }])
            }, " Sprint ", 2),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
                            _ctx.changeType('Hill'),
                                (_ctx.active.Hill = true),
                                // (active.Tempo = false),
                                (_ctx.active.Sprint = false),
                                (_ctx.active.Mountain = false)
                        )),
              class: _normalizeClass(["btn custom-btn shadow-none", { active: _ctx.active.Hill }])
            }, " Hill ", 2),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
                            _ctx.changeType('Mountain'),
                                (_ctx.active.Mountain = true),
                                // (active.Tempo = false),
                                (_ctx.active.Hill = false),
                                (_ctx.active.Sprint = false)
                        )),
              class: _normalizeClass(["btn custom-btn shadow-none", { active: _ctx.active.Mountain }])
            }, " Mountain ", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segments, (s, key) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-2 text-end fw-bold",
              key: key
            }, [
              _createElementVNode("a", {
                href: 
                            'https://www.strava.com/segments/' + s.segmentId
                        ,
                target: "_blank"
              }, _toDisplayString(s.segmentName), 9, _hoisted_9)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (r, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row w-100 py-2 border-bottom border-dark g-0 align-items-center result-row",
          key: index
        }, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(r.rank), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("a", {
              href: 
                        'https://www.strava.com/athletes/' + r.athleteId
                    ,
              target: "_blank"
            }, _toDisplayString(r.athleteName), 9, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(r.totalScore), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.segmentResults, (s, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-2 text-end",
              key: index
            }, [
              (s.score != 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: 
                        'https://www.strava.com/activities/' + s.activityId
                    ,
                    target: "_blank"
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(s.score), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(s.time), 1)
                    ])
                  ], 8, _hoisted_15))
                : (_openBlock(), _createElementBlock("p", _hoisted_19))
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ], 64))
}